export enum LANGUAGE {
  EN = "en",
  FR = "fr"
}
